import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import Vuelidate from "vuelidate";
import { store } from "./store/store";
import Common from "@/mixins/Common.js";
import VModal from "vue-js-modal";
import Toasted from "vue-toasted";
import VueQuillEditor from 'vue-quill-editor'
import Quill from "quill";
import ImageResize from "quill-image-resize-module";
import VideoResize from 'quill-video-resize-module';
import Paginate from 'vuejs-paginate'
Quill.register("modules/imageResize", ImageResize);
Quill.register('modules/videoResize', VideoResize);
import VueTextareaAutosize from 'vue-textarea-autosize'

//image style-tai holboootoi START
var BaseImageFormat = Quill.import('formats/image');
const ImageFormatAttributesList = [
  'alt',
  'height',
  'width',
  'style'
];

class ImageFormat extends BaseImageFormat {
  static formats(domNode) {
    return ImageFormatAttributesList.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }
  format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

Quill.register(ImageFormat, true);
//image style-tai holboootoi END

let Block = Quill.import('blots/block');
var icons = Quill.import('ui/icons');

// Lottery tooltip
class ClearFormat extends Block {
  static create() {
    let node = super.create();
    node.setAttribute('class', this.className);
    return node;
  }

  static formats() {
    return true;
  }
}
ClearFormat.blotName = 'clearformat';
ClearFormat.className = "clearformat"
Quill.register(ClearFormat);
icons['clearformat'] = "<i class='fas fa-level-down-alt'></i>";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false;
Vue.use(VueTextareaAutosize)
Vue.use(Vuelidate);
Vue.use(VModal, { dialog: true });
Vue.use(VModal);
Vue.use(Toasted);
Vue.use(VueQuillEditor);
Vue.component('paginate', Paginate)
Vue.mixin(Common);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
